module.exports = __webpack_public_path__ + "img/40_69_013_600.2e304c63.jpg";